
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","fill":"#fff","viewBox":"0 0 256 256"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M224 64h-69.33l-27.74-20.8a16.12 16.12 0 00-9.6-3.2H72a16 16 0 00-16 16v16H40a16 16 0 00-16 16v112a16 16 0 0016 16h152.89A15.13 15.13 0 00208 200.89V184h16.89A15.13 15.13 0 00240 168.89V80a16 16 0 00-16-16zm-32 136H40V88h45.33l29.87 22.4a8 8 0 004.8 1.6h72zm32-32h-16v-56a16 16 0 00-16-16h-69.33L94.93 75.2a16.12 16.12 0 00-9.6-3.2H72V56h45.33l29.87 22.4A8 8 0 00152 80h72z"}})])
          )
        }
      }
    